import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getPermissionCodeForPath } from "@/utils/permissionPathToCode";

/** Resolves DB permission `code` for a route path using `permissions.activePages`. */
export function usePermissionCodeForPath(targetPath) {
  const activePages = useSelector((s) => s.permissions.activePages);
  return useMemo(
    () => getPermissionCodeForPath(targetPath, activePages),
    [targetPath, activePages]
  );
}
